import type { JSX } from 'solid-js';

// The one horizontal scroll port in this app, and the reason it is a component
// rather than a class.
//
// `.table-scroll` is `@include scroll-port-x` + `hide-scrollbar`
// (`styles/ui/_table.scss`), and seventeen tables wore it as a bare `<div>`.
// A container that scrolls and holds no focusable child is unreachable by
// keyboard: there is nothing to Tab to, so the columns past the fold cannot be
// read without a mouse or a trackpad gesture. That is WCAG 2.1.1 (Keyboard) —
// axe calls it `scrollable-region-focusable` — and it was true of every data
// table in the console, on every screen narrower than its widest row.
//
// IT IS INVISIBLE TO THIS REPO'S AXE LANE, which is why it survived a suite that
// checks every route. `testing/axe-routes.test.tsx` runs against happy-dom,
// which computes no layout: `scrollWidth` never exceeds `clientWidth`, so the
// rule can never fire, on any port, in any state. A source-text gate is the only
// instrument that sees it — `scroll-port-focusable.guard.test.ts`.
//
// `tabindex="0"` alone satisfies 2.1.1. The named `<section>` is what makes the
// stop legible once it is reached: focus landing on an unnamed generic `<div>`
// announces nothing, so every port names the table it holds. The label is
// REQUIRED for that reason — an UNNAMED `<section>` is not exposed as a region
// landmark at all, and an optional label is one a call site forgets.
//
// `<section aria-label>` rather than `<div role="region">`: identical to a
// screen reader, and biome's `useSemanticElements` refuses the second spelling.

export function ScrollPort(props: {
  /** What the port holds, e.g. "Repositories" — announced when focus lands. */
  readonly label: string;
  readonly children: JSX.Element;
}): JSX.Element {
  return (
    <section class="table-scroll" tabindex="0" aria-label={props.label}>
      {props.children}
    </section>
  );
}
